@if (!isSingleLang) {
  <div class="btn-group mb-3" dropdown>
    <button dropdownToggle type="button" class="language-button dropdown-toggle btn btn-light btn-sm btn-square">
      {{currentLanguage}} <span class="caret"></span>
    </button>
    <ul *dropdownMenu class="dropdown-menu" role="menu">
      @for (item of languages; track item) {
        <li role="menuitem" (click)="onLanguageChange(item)"><a class="dropdown-item"
        href="javascript:;">{{item.label}}</a></li>
      }
    </ul>
  </div>
}